import type { Icon } from 'shared/utils'

export const FlameIcon = (props: Icon) => {
    const { size = 24, className = 'flame' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 34 36">
            <path
                d="M34 18.958C34 16.896 33.633 14.919 32.96 13.09C32.5 18.479 29.627 21.247 26.625 19.958C23.813 18.75 25.708 14.041 25.848 11.794C26.084 7.985 25.836 3.625 18.917 0C21.792 5.5 19.25 8.917 16.584 9.125C13.626 9.356 10.917 6.583 11.917 2.083C8.679 4.469 8.585 8.485 9.584 11.083C10.626 13.791 9.542 16.041 7.001 16.291C4.161 16.571 2.583 13.25 4.038 7.958C1.52 10.923 0 14.763 0 18.958C0 28.347 7.611 35.958 17 35.958C26.389 35.958 34 28.347 34 18.958Z"
                fill="#F4900C"
            />
            <path
                d="M27.394 23.957C27.542 27.041 24.833 28.25 23.375 27.666C21.269 26.823 21.834 25.375 21.292 22.375C20.75 19.375 18.667 17.292 15.584 16.375C17.834 22.708 14.337 25.042 12.504 25.459C10.632 25.885 8.751 25.458 8.536 21.452C6.352 23.626 5 26.634 5 29.958C5 30.326 5.023 30.688 5.055 31.048C8.125 34.082 12.342 35.958 17 35.958C21.658 35.958 25.875 34.082 28.945 31.048C28.977 30.688 29 30.326 29 29.958C29 27.771 28.416 25.722 27.394 23.957Z"
                fill="#FFCC4D"
            />
        </svg>
    )
}
